module.exports = __webpack_public_path__ + "static/media/021-snowflake.21ccb8d6.svg";